import dayjs from 'dayjs'
import CONFIG from '@/config'

export const wxuuid = function () {
  var s = [];
  var hexDigits = "0123456789abcdef";
  for (var i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
  }
  s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
  s[8] = s[13] = s[18] = s[23] = "-";
 
  var uuid = s.join("");
  return uuid
}

export const getMaxDate = function (dateArr) {
	return dayjs(Math.max(...dateArr.map(d => dayjs(d).valueOf()))).format('YYYY-MM-DD')
}

export const truncate = function (val, length) {
	return val.length > length ? val.slice(0, length) + '...' : val
} 


export const transforomData = (str) => {
  return new Date(str).getTime()
}

export const stringfyParam = (data) => Object.keys(data).map(key => `${key}=${data[key]}`).join('&')

/**
 * 由于uniapp入口和子页面同时异步加载的问题，故尝试多次获取token解决子页面请求header无token问题
 */
export const retryGetToken = () => {
	// 2s内轮询
	const retryTime = dayjs().add(20, 'second').valueOf()
	let timer = null
	
	return new Promise((resolve, reject) => {
		if (uni.getStorageSync('token')) return resolve(uni.getStorageSync('token'))
		timer = setInterval(() => {
			const token = uni.getStorageSync('token')
			if (!token) {
				if (dayjs().valueOf() >= retryTime) {
					clearInterval(timer)
					reject('未查询到token')
				}
			} else {
				resolve(token)
			}
		}, 50)
	})
}

export const isIos = () => uni.getDeviceInfo().system.toLowerCase().includes('ios')

// 深拷贝
export const deepClone = (obj, hash = new WeakMap()) => {
	// 日期对象直接返回一个新的日期对象
	if (obj instanceof Date){
		return new Date(obj);
	} 
	//正则对象直接返回一个新的正则对象     
	if (obj instanceof RegExp){
		return new RegExp(obj);     
	}
	//如果循环引用,就用 weakMap 来解决
	if (hash.has(obj)){
		return hash.get(obj);
	}
	// 获取对象所有自身属性的描述
	let allDesc = Object.getOwnPropertyDescriptors(obj);
	// 遍历传入参数所有键的特性
	let cloneObj = Object.create(Object.getPrototypeOf(obj), allDesc)

	hash.set(obj, cloneObj)
	for (let key of Reflect.ownKeys(obj)) { 
		if (typeof obj[key] === 'object' && obj[key] !== null) {
			cloneObj[key] = deepClone(obj[key], hash);
		} else {
			cloneObj[key] = obj[key];
		}
	}
	return cloneObj
}

/**
 * 判断是否可以转数字
 */
export const isNumber = (str) => {
  return str ? !isNaN( Number(str)) : false
}

/**
 * 根据列表的value获取text描述
 */
export const getTextByValue = (val, arr) => arr.find(item => item.value === val).text

/**
 * 重定向至微信授权页
 */
export const redirectToAuth = () => {
	const redirectUrl = encodeURIComponent(`${window.location.origin}#/subpages/redirect`)
	const routerUrl = encodeURIComponent(`${window.location.hash}`)
	window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${CONFIG.appid}&redirect_uri=${redirectUrl}&state=${routerUrl}&response_type=code&scope=snsapi_userinfo#wechat_redirect`
}
